import { useI18n as o } from "next-localization";
import { u as m } from "./use-get-is-facility-open.Cngix8AG.js";
const g = (e) => {
  var d, u;
  const { t: s } = o(), C = (d = e == null ? void 0 : e.currentOperatingHours) == null ? void 0 : d.open, n = (u = e == null ? void 0 : e.currentOperatingHours) == null ? void 0 : u.close, { isFacilityCurrentlyOpen: p } = m(C, n, e), t = (e == null ? void 0 : e.operatingStatusCodeOverride) ?? (e == null ? void 0 : e.operatingStatusCode);
  let r;
  e != null && e.isTemporarilyClosed ? r = "ClosedTemporary" : p === !1 && t === "Open" ? r = "ClosedPermanent" : p === void 0 && t === "Open" ? r = void 0 : r = t;
  const a = {
    ClosedPermanent: {
      text: s("Locations.Card.Closed"),
      color: "red"
    },
    ClosedTemporary: {
      text: s("Locations.Card.TempClosed"),
      color: "orange"
    },
    Planned: {
      text: s("Locations.Card.ComingSoon"),
      color: "teal"
    },
    Open: {
      text: s("Locations.Card.Open"),
      color: "green"
    }
  };
  return r ? {
    operatingStatus: a[r],
    isTemporarilyClosed: r === "ClosedTemporary"
  } : {
    operatingStatus: void 0,
    isTemporarilyClosed: void 0
  };
};
export {
  g as u
};
